<template>
  <div class="popup" id="caption">
    <div @click="close()" class="close-popup">
      <font-awesome-icon icon="times"></font-awesome-icon>
    </div>
    <div class="caption-w">
      <ul class="legende">
        <li v-for="(item, i) in list" :key="i">
          <h3>
            <font-awesome-icon :style="{color: item.color}" :icon="item.icon" /> {{$t(`${item.content}.title`)}}
          </h3>
          <p v-html="$t(`${item.content}.text`)" class="text-1"> </p>
        </li>
      </ul>
      <ul class="signaux">
        <li v-for="(item, i) in list2" :key="i">
          <h3>
            <font-awesome-icon :style="{color: item.color}" icon="exclamation-circle" /> {{$t(`${item.content}.title`)}}
          </h3>
          <p v-html="$t(`${item.content}.text`)" class="text-1"> </p>
        </li>
      </ul>
    </div>
    <div v-if="comparative">
      <ul class="legende-comparee">
        <li v-for="(item, i) in list3" :key="i">
          <img :style="getOpacity(item.opacity)" :src="require(`@/assets/icons/${item.icon}.svg`)" alt="">
          <span :class="item.helperClass">
            {{item.helper}}
          </span>
          <p v-html="$t(`${item.content}.title`)" class="text-1"></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    comparative: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [
        {
          content: "positiveImpact",
          icon: "circle",
          color: "#3c7cc4"
        },

        {
          content: "averageSatisfaction",
          icon: "walking",
          color: "#efcd43"
        },
        {
          content: "negativeImpact",
          icon: "circle",
          color: "#c4042c"
        },
        {
          content: "occurrence",
          icon: "circle",
          color: "#13b5cb"
        }
      ],
      list2: [
        {
          content: "prioritySite",
          color: "#f9b84b"
        },
        {
          content: "weaknessCaption",
          color: "#ef7a82"
        },
        {
          content: "strengthCaption",
          color: "#2a446b"
        },
        {
          content: "goodPracticeCaption",
          color: "#32b0a7"
        }
      ],
      list3: [
        {
          content: "bddf",
          icon: "legende-compare"
        },
        {
          content: "bpf",
          icon: "legende-compare",
          opacity: 0.4
        },
        {
          content: "risingOccurrence",
          icon: "occurence-hausse",
          helper: "(+1.4)",
          helperClass: "hausse"
        },
        {
          content: "stableOccurrence",
          icon: "occurence-stable"
        },
        {
          content: "fallingOccurrence",
          icon: "occurence-baisse",
          helper: "(-1.8)",
          helperClass: "baisse"
        }
      ]
    };
  },
  methods: {
    close() {
      document.getElementById("caption").classList.remove("active");
    },
    getOpacity(o) {
      if (o) {
        return {
          opacity: o
        };
      }
    }
  }
};
</script>

<style lang="scss">
#caption {
  max-height: inherit;
  .close-popup {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  .caption-w {
    display: flex;
    justify-content: center;
    > ul {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      > li {
        flex: 0 0 auto;
        min-width: 280px;
        padding: 1em 3em;
        border-right: 2px dotted #d6d6d6;
        &:nth-child(2n) {
          border-right: 2px solid transparent;
        }
        h3 {
          padding: 1em 0;
          padding-top: 0;
          text-transform: uppercase;
          font-size: 0.9rem;
          font-weight: 700;
          svg {
            margin-right: 5px;
          }
        }
        p {
          font-size: 0.8rem;
          color: #444;
          line-height: 1.5;
          letter-spacing: 0;
        }
      }
    }
  }
  .legende {
    border-right: 1px solid #000;
  }
}
.legende-comparee {
  display: flex;
  align-items: center;
  justify-content: center;
  li {
    display: flex;
    align-items: center;
    padding: 2em 1em;
    span {
      margin-right: 10px;
    }
    img {
      width: 12px;
      height: auto;
      margin: 0 7px;
    }
  }
}
.baisse {
  color: #bf0b0b;
}
.hausse {
  color: #77c311;
}

@media screen and (max-width: 1300px) {
  #caption {
    .legende {
      border-right: none;
    }
    .caption-w {
      display: block;
      > ul {
        > li {
          width: auto;
        }
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .legende-comparee {
    flex-wrap: wrap;
    li {
      width: 50%;
      padding: 1em 0.5em;
    }
  }
  #caption {
    max-height: 75vh;
    overflow: auto;

    .caption-w {
      > ul {
        display: block;
        > li {
          border-right: none;
        }
      }
    }
  }
}
</style>
